/**
 * 📄 AsistenciaPage.jsx
 * Página wrapper para asistencias
 */
import React from "react";
import AsistenciaList from "../components/Asistencia/AsistenciaList";

export default function AsistenciaPage() {
    return <AsistenciaList />;
}
